import { PageTitle } from '#app/components/layout/page-title.tsx'

export default function NutzungsbedingungenPage() {
	return (
		<>
			<PageTitle titleText="Nutzungsbedingungen und Datenschutzerklärung" />
			<div className="container">
				<div id="ef-license-note">
					<h2 className="text-h2 font-alumni text-pcteal-700 mb-8 font-normal">
						Nutzungsbedingungen
					</h2>
					<ul className="ml-8 flex list-decimal flex-col gap-4">
						<li>
							Die angeführten Bestimmungen gelten für die Nutzung der von
							publicare GmbH eingerichteten Online-Plattform. Die Nutzung dieser
							Plattform ist ausschließlich Personen gestattet, die von publicare
							GmbH hierzu berechtigt wurden und über die von publicare GmbH zur
							Verfügung gestellten Zugangsdaten verfügen (Nutzer). Die Nutzer
							verpflichten sich, die Online-Plattform und die darin zur
							Verfügung gestellten Informationen, Downloads bzw. Foren etc.
							ausschließlich entsprechend den nachfolgenden Nutzungsbedingungen
							zu verwenden.
						</li>
						<li>
							Voraussetzung zur Nutzung ist die Registrierung bei publicare
							GmbH, welche daraufhin die Zugangsdaten an den Nutzer übermittelt.
							Der Nutzer ist verpflichtet, die zur Anmeldung erforderlichen
							Daten wahrheitsgemäß anzugeben. publicare GmbH beachtet bei der
							Speicherung und Verarbeitung dieser Daten die geltenden
							datenschutzrechtlichen Bestimmungen, wie in der
							Datenschutzerklärung (vgl. Anhang zu diesen Nutzungsbedingungen)
							näher geregelt wird. Mit der Anmeldung durch den Nutzer und der
							Übermittlung der Zugangsdaten durch publicare GmbH kommt ein
							Nutzungsvertrag mit Inhalt dieser Nutzungsbedingungenzustande
						</li>

						<li>
							publicare GmbH kann jederzeit die Berechtigung des Nutzers ohne
							Angabe von Gründen widerrufen und diesem für die Zukunft die
							Nutzung der Plattform verbieten. Der Nutzer verpflichtet sich, die
							Zugangsdaten geheim zu halten und weder an Dritte weiterzugeben
							noch diesen sonst zugänglich zu machen.{' '}
						</li>
						<li>
							Der Nutzer anerkennt, dass Marken-, Urheber- und Nutzungsrechte
							sowie jegliches geistige Eigentum im Zusammenhang mit dem zur
							Verfügung gestellten Daten- und Bildmaterial sowie an sämtlichen
							verwendeten Texten, Bildern, Grafiken, Geräuschen, Animationen,
							Videos, Marken, Warenzeichen und dergleichen bei publicare GmbH
							bzw. beim jeweiligen Urheber verbleiben und dem Nutzer lediglich
							die jederzeit widerrufbare Berechtigung eingeräumt wird, das zur
							Verfügung gestellte Daten- und Bildmaterial ausschließlich zu
							Schulungs- und Lernzwecken zu verwenden. Durch die Verwendung bzw.
							Zurverfügungstellung wird keine Lizenz zur Nutzung des geistigen
							Eigentums von publicare GmbH bzw. von Dritten erteilt.
						</li>
						<li>
							Der interne Bereich dient dazu, den zur Nutzung befugten und mit
							publicare GmbH-Produkten beschäftigen Personen Informationen über
							publicare GmbH bzw. publicare GmbH- Produkte zur Verfügung zu
							stellen und den Nutzer im Zusammenhang mit Informationen über
							publicare GmbH-Produkte und deren rechtlichen und technischen
							Zusammenhängen zu schulen. Der Nutzer anerkennt aus diesem Grund,
							dass diese Informationen ausschließlich zu oben angeführten
							Zwecken verwendet werden. Insbesondere verpflichtet sich der
							Nutzer, etwaige zur Verfügung gestellte Wissensabfragen, Quiz oder
							andere interaktive Trainingsformen ausschließlich selbst
							durchzuführen.
						</li>
						<li>
							Durch diese Nutzungsbedingungen werden keine dem Nutzer
							auferlegten Pflichten, die sich aus anderen Verträgen mit
							publicare GmbH ergeben, berührt. publicare GmbH leistet keine
							Gewähr für die Verfügbarkeit, Vollständigkeit, Richtigkeit und
							Aktualität der zur Verfügung gestellten Informationen und
							schließt, soweit rechtlich zulässig, jegliche Haftung für Schäden,
							die im Zusammenhang mit der Benutzung der Plattform entstehen,
							aus.
						</li>
						<li>
							Die durch die Online-Plattform zur Verfügung gestellten
							Informationen sowie die Zugangdaten unterliegen der Geheimhaltung
							und dürfen nicht an dritte Personen weitergegeben oder diesen –
							auch nur vorübergehend – zur Verfügung gestellt werden. Der Nutzer
							verpflichtet sich, die erwähnten Informationen und insbesondere
							die Zugangsdaten vor dem Zugriff durch Dritte bestmöglich zu
							schützen. Gegenüber Kunden ist der Einsatz des zur Verfügung
							gestellte Daten- und Bildmaterials nur dann und in dem Umfang
							zulässig, als es ausdrücklich dafür freigegeben ist.
						</li>
						<li>
							Für die technischen Voraussetzungen zur Nutzung des Angebots hat
							der Nutzer auf eigene Kosten und eigenes Risiko zu sorgen. Der
							Nutzer verpflichtet sich, eine aktuelle Virensoftware zu verwenden
							und entsprechende Firewall zu aktivieren und alles zu tun bzw. zu
							unterlassen, damit die Plattform nicht mit Viren oder sonstigen
							schädlichen Programmen (Malware) infiziert wird.
						</li>
						<li>
							Der Nutzer ist verpflichtet, die Online-Plattform sachgerecht zu
							benutzen. Die Erstellung, Verwendung oder Speicherung von Inhalten
							mit verletzenden, beleidigenden, bedrohenden, obszönen,
							rassistischen, menschen- und religionsverachtenden oder sonst
							gegen die guten Sitten, demokratische Grundwerte oder gesetzliche
							Bestimmungen verstoßenden Bestandteilen ist ebenso untersagt, wie
							auf solche Inhalte durch Links oder die sonstige Angabe von
							Internet-Adressen zu verweisen. Insbesondere sind die Urheber-,
							Marken- und sonstigen Schutzrechte Dritter zu achten.
						</li>
						<li>
							Im Falle etwaiger Rechtsstreitigkeiten im Zusammenhang mit dem
							Inhalt und der Nutzung des internen Bereiches kommt ausschließlich
							österreichisches Recht zur Anwendung und wird das sachlich für
							publicare GmbH zuständige Gericht als ausschließlicher
							Gerichtsstand vereinbart.
						</li>

						<li>
							Publicare GmbH ist jederzeit berechtigt, den Betrieb der
							Online-Plattform ein zustellen oder die Erbringung von Leistungen
							ganz oder teilweise vorübergehend zu verweigern. Dem Nutzer
							entstehen aus einer Sperre der Leistungen keine Ansprüche.
						</li>
					</ul>
				</div>
			</div>
		</>
	)
}
